module.exports = require("./rw.d.ts");